import template from './employee_document_count_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeeDocumentCountReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeDocumentCountReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeDocumentCountReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeDocumentCountReportHelp',
	dialog_class: EmployeeDocumentCountReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_document_count_report_help',
	provider: 'ps'
};
